import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';
import { EntityManifestService } from '@workbuddy/services/entities';
import { getEntityBySlug } from '@workbuddy/services/entities/entity.manifest.registry';
import { entityListUrl, entityRecordUrl } from '@workbuddy/ui/v2/blocks/entity.record';
import { isEntityRecordFeatureEnabled } from '@workbuddy/ui/v2/blocks/entity.record/entity.operation.route.guard';
import { findLegacyEntityRoute, isLegacyEntityDisabled, legacyRecordId } from './legacy.entity.routes';

/** Whether the v2 entity behind a slug is rolled out to this tenant. */
export function isV2EntityEnabled(manifests: EntityManifestService, slug: string): boolean {

    const entity = getEntityBySlug(slug);
    if (!entity) return false;
    return isEntityRecordFeatureEnabled(manifests.getManifest(entity)?.featureFlag, ConfigService.environment.featureFlags);
}

/**
 * Sends a legacy screen to its v2 replacement once legacy is off for the tenant, keeping the record
 * when the URL names one, so bookmarks and pasted links still land on the same document.
 */
export function legacyEntityRouteGuard(slug: string): CanActivateFn {

    return (_route, state) => {

        const entry = findLegacyEntityRoute(slug);
        if (!entry) return true;

        const manifests = inject(EntityManifestService);
        if (!isLegacyEntityDisabled(entry, ConfigService.environment.featureFlags, isV2EntityEnabled(manifests, slug))) return true;

        const id = legacyRecordId(entry, state.url);
        // The manifest owns where a record opens; the generic preview page is the fallback.
        const recordUrl = id ? manifests.routes(getEntityBySlug(slug)!)?.record?.(id) ?? entityRecordUrl(slug, 'preview', id) : null;
        const target = recordUrl ?? entityListUrl(slug);
        return inject(Router).parseUrl(target!);
    };
}
